import React, { useState, useEffect } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { Container, Row, Col, Spinner } from "react-bootstrap";

export default function BlogCard({ excludeId }) {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "blogs"), (snapshot) => {
      const blogsData = snapshot.docs
        .map((doc) => {
          const blogData = doc.data();
          const formattedDate = blogData.createdAt
            ? new Date(blogData.createdAt.seconds * 1000).toLocaleDateString()
            : "N/A";
          return {
            id: doc.id,
            ...blogData,
            formattedDate,
          };
        })
        .filter((blog) => blog.id !== excludeId);
      setBlogs(blogsData);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [excludeId]);

  return (
    <section className="pt-3 mb-5" id="blogs">
      <Container>
        <div className="blogmain">
          {loading ? (
            <Container className="d-flex flex-column align-items-center justify-content-center">
              <Spinner animation="border" variant="primary" />
              <p className="mt-3">Loading Blogs...</p>
            </Container>
          ) : (
            <Row>
              {blogs.map((blog) => (
                <Col
                  key={blog.id}
                  xs={12}
                  sm={6}
                  md={4}
                  lg={4}
                  xl={4}
                  className="mb-4"
                >
                  <div className="text-decoration-none d-flex h-100">
                    <div className="BlogCard h-100 rounded-3 border-0 shadow overflow-hidden">
                      <div className="blogcard1 d-flex">
                        <img
                          alt={blog.title}
                          src={blog.imageUrl || "placeholder-image-url"}
                          className="incardimg img-fluid"
                        />
                      </div>
                      <div className="card-body px-3">
                        <p className="text-muted mt-2 BlogformattedDate">{blog.formattedDate}</p>
                        <h5 className="card-title text-dark">
                          {blog.title || "No title available"}
                        </h5>
                        <p
                          className="Blogcontent card-text text-muted mt-2"
                          dangerouslySetInnerHTML={{ __html: blog.content }}
                        />
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          )}
        </div>
      </Container>
    </section>
  );
}
